// extracted by mini-css-extract-plugin
module.exports = {"widgetsFilter":"WidgetsFilter_widgetsFilter__28YVJ","filters":"WidgetsFilter_filters__12fMi"};